import type { TreeItem } from "../../types";

/**
 * Get the icon color based on tree item type.
 */
export function getIconColor(item: TreeItem, isActive = false): string {
  if (isActive) {
    return "text-primary";
  }
  switch (item.type) {
    case "root-folder":
      return "text-neutral-dim";
    default:
      return "text-neutral-dim";
  }
}

/**
 * Get the font weight based on tree item type.
 */
export function getFontWeight(item: TreeItem): string {
  switch (item.type) {
    case "root-folder":
      return "font-medium";
    case "objective":
    case "project-tree-folder":
    case "entity-collection":
      return "font-normal";
    default:
      return "font-normal";
  }
}

/**
 * Check if a path is currently active (exact match or starts with the path).
 */
export function isPathActive(currentPath: string, itemPath: string): boolean {
  return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);
}

export function hasActiveDescendant(item: TreeItem, activeLineageNodeIds: Set<string>): boolean {
  if (activeLineageNodeIds.has(item.id)) {
    return true;
  }

  if (!item.children) {
    return false;
  }

  return item.children.some((child) => hasActiveDescendant(child, activeLineageNodeIds));
}
